<template>
  <router-view v-slot="{ Component }" :key="$route.path">
    <keep-alive>
      <component :is="Component" />
    </keep-alive>
  </router-view>
</template>
<script>
export default {
  name: "App",
  components: {},
  methods: {
    changeLayoutType(layoutType) {
      this.$store.commit("changeLayoutType", { layoutType });
      document.body.setAttribute("data-pc-layout", layoutType);
    },
  },
  mounted() {
    document.body.setAttribute("data-pc-layout", "horizontal");
  },
};
</script>
